/* =============================================
   Back in Stock — Klaviyo Integration
   Horizon Theme
   ============================================= */

(function () {
  'use strict';

  const KLAVIYO_PUBLIC_KEY = 'SuD5J2';
  const KLAVIYO_REVISION = '2024-06-15';

  let currentVariantId = null;
  let currentIsOOS = false;

  const overlay = document.getElementById('bis-overlay');
  const backdrop = overlay?.querySelector('.bis-backdrop');
  const closeBtn = document.getElementById('bis-close-btn');
  const submitBtn = document.getElementById('bis-submit');
  const emailInput = document.getElementById('bis-email');
  const errorEl = document.getElementById('bis-error');
  const formEl = document.getElementById('bis-form-container');
  const successEl = document.getElementById('bis-success');

  if (overlay) {
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
  }

  function getAddToCartBtn() {
    const buttons = Array.from(
      document.querySelectorAll(
        'button[type="submit"][name="add"], .product-form__submit, add-to-cart-component button, .add-to-cart-button'
      )
    );

    return (
      buttons.find((btn) => {
        if (btn.id === 'bis-main-notify-btn') return false;
        if (btn.classList.contains('bis-notify-btn')) return false;
        if (btn.closest('sticky-add-to-cart')) return false;

        const rect = btn.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      }) ||
      buttons.find((btn) => {
        if (btn.id === 'bis-main-notify-btn') return false;
        if (btn.classList.contains('bis-notify-btn')) return false;
        if (btn.closest('sticky-add-to-cart')) return false;
        return true;
      }) ||
      null
    );
  }

  function getSelectedVariantId() {
    if (window.__bis_selected_variant_id__) {
      return String(window.__bis_selected_variant_id__);
    }

    if (currentVariantId) {
      return String(currentVariantId);
    }

    const selectedSizeBtn = document.querySelector(
      'button.mr-size-inline__size.bis-selected, button.mr-size-inline__size.is-selected'
    );

    if (selectedSizeBtn?.dataset.variantId) {
      return String(selectedSizeBtn.dataset.variantId);
    }

    const checkedRadio = document.querySelector(
      'variant-picker input[type="radio"][data-current-checked="true"], variant-picker input[type="radio"]:checked'
    );

    if (checkedRadio?.dataset.variantId) {
      return String(checkedRadio.dataset.variantId);
    }

    return window.__bis_default_variant_id__
      ? String(window.__bis_default_variant_id__)
      : null;
  }

  function applyCustomIcon(btn) {
    if (!window.__bis_icon_url__) return;

    btn.style.setProperty('--bis-icon-url', `url("${window.__bis_icon_url__}")`);
    btn.style.setProperty('--bis-icon-size', `${window.__bis_icon_size__ || 18}px`);
    btn.style.setProperty('--bis-icon-top', `${window.__bis_icon_top__ ?? -8}px`);
    btn.style.setProperty('--bis-icon-right', `${window.__bis_icon_right__ ?? -6}px`);
    btn.classList.add('bis-has-custom-icon');
  }

  function ensureNotifyButton() {
    if (!overlay) return;

    const addToCartBtn = getAddToCartBtn();
    if (!addToCartBtn) return;

    let notifyBtn = document.getElementById('bis-main-notify-btn');

    if (!notifyBtn) {
      notifyBtn = document.createElement('button');
      notifyBtn.id = 'bis-main-notify-btn';
      notifyBtn.type = 'button';
      notifyBtn.className = 'bis-notify-btn button button--primary';
      notifyBtn.setAttribute('data-bis-trigger', '');
      notifyBtn.innerHTML = '<span class="bis-notify-text">Notify me</span>';

      addToCartBtn.insertAdjacentElement('afterend', notifyBtn);
    }

    const variantId = getSelectedVariantId();

    if (variantId) {
      notifyBtn.dataset.variantId = variantId;
    }

    if (currentIsOOS) {
      document.body.classList.add('bis-oos-active');

      addToCartBtn.style.display = 'none';
      notifyBtn.style.display = '';
      notifyBtn.hidden = false;
      notifyBtn.removeAttribute('hidden');
    } else {
      document.body.classList.remove('bis-oos-active');

      addToCartBtn.style.removeProperty('display');
      notifyBtn.style.display = 'none';
      notifyBtn.hidden = true;
      notifyBtn.setAttribute('hidden', '');
    }
  }

  function markOOSButtons() {
    if (!overlay) return;

    const buttons = document.querySelectorAll(
      'button.mr-size-inline__size.is-disabled, button.mr-size-inline__size[disabled], button.mr-size-inline__size[aria-disabled="true"]'
    );

    buttons.forEach((btn) => {
      btn.dataset.bisOos = 'true';
      btn.classList.add('bis-oos-enabled');

      applyCustomIcon(btn);

      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');

      const label = btn.textContent.trim();

      if (label) {
        btn.setAttribute('aria-label', `${label} - Notify me when back in stock`);
      }
    });
  }

  function selectOOSButton(btn) {
    const variantId =
      btn.dataset.variantId ||
      btn.getAttribute('data-variant-id') ||
      getSelectedVariantId();

    document.querySelectorAll('button.mr-size-inline__size').forEach((button) => {
      button.classList.remove('bis-selected', 'is-selected', 'selected', 'active');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('data-current-checked', 'false');
    });

    btn.classList.add('bis-selected', 'is-selected');
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('data-current-checked', 'true');

    if (variantId) {
      window.__bis_selected_variant_id__ = String(variantId);
      currentVariantId = String(variantId);
    }

    currentIsOOS = true;
    ensureNotifyButton();
  }

  function clearOOSSelection() {
    document.querySelectorAll('button.mr-size-inline__size').forEach((button) => {
      button.classList.remove('bis-selected');
      button.removeAttribute('aria-pressed');
      button.removeAttribute('data-current-checked');
    });

    window.__bis_selected_variant_id__ = null;
    currentVariantId = null;
    currentIsOOS = false;
    document.body.classList.remove('bis-oos-active');

    const notifyBtn = document.getElementById('bis-main-notify-btn');
    if (notifyBtn) {
      notifyBtn.style.display = 'none';
      notifyBtn.hidden = true;
      notifyBtn.setAttribute('hidden', '');
    }

    const addToCartBtn = getAddToCartBtn();
    if (addToCartBtn) {
      addToCartBtn.style.removeProperty('display');
    }

    setTimeout(() => {
      const freshAddToCartBtn = getAddToCartBtn();
      if (freshAddToCartBtn) {
        freshAddToCartBtn.style.removeProperty('display');
      }
    }, 50);
  }

  function openOverlay(variantId) {
    if (!overlay) return;

    currentVariantId = variantId || getSelectedVariantId();

    if (emailInput) emailInput.value = '';
    if (errorEl) errorEl.textContent = '';
    if (formEl) formEl.classList.remove('is-hidden');
    if (successEl) successEl.classList.remove('is-visible');
    if (submitBtn) submitBtn.classList.remove('is-loading');

    overlay.hidden = false;
    overlay.removeAttribute('style');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      if (emailInput) emailInput.focus();
    }, 300);
  }

  function closeOverlay() {
    if (!overlay) return;

    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.style.overflow = '';
  }

  async function submitBackInStock(email, variantId) {
    const cleanVariantId = String(variantId || '').replace(
      'gid://shopify/ProductVariant/',
      ''
    );

    const klaviyoVariantId = `$shopify:::$default:::${cleanVariantId}`;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: klaviyoVariantId,
            },
          },
        },
      },
    };

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(KLAVIYO_PUBLIC_KEY)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION,
        },
        body: JSON.stringify(payload),
      }
    );

    const responseText = await response.text();

    if (!response.ok) {
      console.error('[BIS] Klaviyo error:', response.status, responseText);
      throw new Error('Klaviyo error ' + response.status + ': ' + responseText);
    }

    return true;
  }

  function removeThemeNotifyButton() {
    document.querySelectorAll('button, a').forEach((el) => {
      const text = el.textContent.trim().toLowerCase();

      if (
        text.includes('translation missing') ||
        text.includes('products.product.notify_me')
      ) {
        if (!el.closest('.bis-overlay') && el.id !== 'bis-main-notify-btn') {
          el.remove();
        }
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const trigger = event.target.closest(
        '[data-bis-trigger], #bis-main-notify-btn, .bis-notify-btn'
      );

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const variantId = trigger.dataset.variantId || getSelectedVariantId();
        openOverlay(variantId);
        return;
      }

      const sizeBtn = event.target.closest('button.mr-size-inline__size');

      if (sizeBtn) {
        if (sizeBtn.dataset.bisOos === 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
          selectOOSButton(sizeBtn);
          return;
        }

        clearOOSSelection();
      }
    },
    true
  );

  if (overlay) {
    closeBtn?.addEventListener('click', closeOverlay);
    backdrop?.addEventListener('click', closeOverlay);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeOverlay();
      }
    });

    submitBtn?.addEventListener('click', async function () {
      const email = emailInput?.value.trim();

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorEl) errorEl.textContent = 'Add a valid email address';
        emailInput?.focus();
        return;
      }

      if (errorEl) errorEl.textContent = '';
      submitBtn.classList.add('is-loading');

      try {
        const variantId = getSelectedVariantId();

        if (!variantId) {
          throw new Error('No variant ID found.');
        }

        await submitBackInStock(email, variantId);

        formEl?.classList.add('is-hidden');
        successEl?.classList.add('is-visible');

        setTimeout(closeOverlay, 2500);
      } catch (error) {
        console.error('[BIS]', error);

        if (errorEl) {
          errorEl.textContent = 'Something went wrong, please try again.';
        }
      } finally {
        submitBtn.classList.remove('is-loading');
      }
    });
  }

  function initBIS() {
    if (!overlay) return;

    removeThemeNotifyButton();
    markOOSButtons();
    ensureNotifyButton();

    const sizeObserver = new MutationObserver(function () {
      window.requestAnimationFrame(function () {
        markOOSButtons();
        ensureNotifyButton();
        removeThemeNotifyButton();
      });
    });

    const root = document.querySelector(
      'mr-size-overlay-picker, variant-picker, .variant-picker__form'
    );

    if (root) {
      sizeObserver.observe(root, {
        childList: true,
        subtree: true,
      });
    }

    const bodyObserver = new MutationObserver(function () {
      window.requestAnimationFrame(removeThemeNotifyButton);
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBIS);
  } else {
    initBIS();
  }

  window.BISOverlay = {
    open: openOverlay,
    close: closeOverlay,
  };
})();